module.exports = __webpack_public_path__ + "img/185b3a0.png";